import React from 'react';
import PropTypes from 'prop-types';
import ColumnLeft from './ColumnLeft';
import ColumnContentRight from './ColumnContentRight';

const Row = (props) => {
    const {
        horseList,
        rowYear,
    } = props;

    return (
        <div className="hp-recentStakesPerformers__container__content__row">
            <ColumnLeft rowYear={rowYear} />
            <div className="hp-recentStakesPerformers__container__content__row__right">
                {
                    horseList.map(horse =>
                        <ColumnContentRight
                            key={rowYear + horse.horseName}
                            horseDetails={horse}
                        />
                    )
                }
            </div>
        </div>
    );
};

Row.propTypes = {
    horseList: PropTypes.arrayOf(PropTypes.shape({})),
    rowYear: PropTypes.string,
};

export default Row;




// WEBPACK FOOTER //
// ./src/js/horse/recentStakesPerformers/components/Row.jsx